import axiosInstance from "../../config/Axios";

export const getOrders = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/orders/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getPendingOrders = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/orders/pending-order/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getOrderById = async (id) => {
    try {
        return await axiosInstance({
            method: 'get',
            url: `/api/orders/${id}/`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createOrder = async (orderData) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/orders/',
            data: orderData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateOrder = async (id, orderData) => {
    try {
        return await axiosInstance({
            method: 'put',
            url: `/api/orders/${id}/`,
            data: orderData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteOrder = async (id) => {
    if (!id) {
        return Promise.reject(new Error('Order ID is required'));
    }
    try {
        const response = await axiosInstance({
            method: 'delete',
            url: `/api/orders/${id}/`,
        });
        return response;
    } catch (error) {
        console.error('Delete API Error:', error?.response?.data || error.message);
        return Promise.reject(error);
    }
};

export const getOrdersByDuka = async (dukaId, { page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/orders/',
            params: {
                duka: dukaId,
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getOrdersByDukaAndDate = async (dukaId, date, { page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: `/api/orders/duka/${dukaId}/date/${date}/`,
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getOrdersByDukaAndDateAndStatus = async (dukaId, date, status, { page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: `/api/orders/duka/${dukaId}/date/${date}/status/${status}/`,
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const placeCashOrder = async (orderData) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/orders/cash-order/',
            data: orderData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const consolidateOrders = async (orderIds) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/orders/consolidate/',
            data: { order_ids: orderIds }
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const executeDelivery = async (orderId) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: `/api/orders/${orderId}/execute-delivery/`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};
